import React from 'react';
export function Guarantee() {
  return <section className="py-10 md:py-[60px] px-5 bg-sky text-center" data-id="element-86">
      <div className="max-w-[560px] mx-auto bg-white border-2 border-blue rounded-2xl p-6 md:p-10" data-id="element-87">
        <div className="text-[48px] md:text-[56px] mb-3 md:mb-4 leading-none" data-id="element-88">
          🛡️
        </div>
        <h2 className="font-display text-[28px] md:text-[36px] text-navy mb-2 md:mb-3 leading-tight" data-id="element-89">
          7 Días de garantía total
        </h2>
        <p className="text-[14px] md:text-[15px] text-text-muted leading-relaxed" data-id="element-90">
          Abrís los tomos, usás los bonos, aplicás las cartas modelo. Si no es
          lo que esperabas: sin preguntas, sin formularios, sin drama. Te
          devolvemos el 100% de lo que pagaste.
          <br data-id="element-91" />
          <br data-id="element-92" />
          <strong data-id="element-93">Tasa de devoluciones menor al 1%.</strong>
        </p>
      </div>
    </section>;
}